const columns = () => ([
  {
    title: 'Name',
    dataIndex: 'displayName',
    key: 'name',
  },
  {
    title: 'Color',
    dataIndex: 'color',
    key: 'color',
    customRender: ({ text }) => `Color: ${text || 'N/A'}`,
  },
  {
    title: 'Actions',
    dataIndex: 'actions',
    key: 'actions',
  },
]);

export default columns;
